function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1 -1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 24V12m6 6H12",
  stroke: "#FFF",
  strokeWidth: 2,
  strokeLinecap: "round"
}));
function SvgPlusWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34
  }, props), _ref);
}
export default SvgPlusWhite;